var map = {
	"./black/xiazailuxiang.png": "GrA0",
	"./blue/xiazailuxiang.png": "nFkq",
	"./white/xiazailuxiang.png": "KCJe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "h4+T";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiazailuxiang\.png$
// module id = h4+T
// module chunks = 24